module.exports = __webpack_public_path__ + "img/global_view.6c0e1795.png";